import React, { useEffect, useState } from 'react'
import HPTSelect from './HPTSelect'
import FormsService from '../../../services/api/forms.service'

const FormSelector = (props) => {
    const [formsList, setFormsList] = useState();
    const [isLoader, setIsLoader] = useState(false)
    const [selectedForm, setSelectedForm] = useState();
    const pullForms = () => {
        setIsLoader(true)
        FormsService.getFormsList({})
            .then(res => {
                //If isDisabled is true, that option will be greyed out and not selectable. - public url is not created in this case
                const processedForms = res?.data
                    ?.filter(form => form.isActivated === 1) // Only keep activated forms
                    ?.map(form => ({
                        ...form,
                        isDisabled: form.publicUrl == null // Disable if no publicUrl
                    }));
                setFormsList(processedForms);
                setIsLoader(false)
            }).catch((err) => {
                setIsLoader(false)
            });
    }

    useEffect(() => {
        pullForms()
    }, [])

    const setCurrentForm = async (form) => {
        setSelectedForm(form);
        if (props.onSelected) props.onSelected(form)
    }

    return (
        <HPTSelect
            style={props.style}
            className="react-select-container"
            classNamePrefix="react-select"
            isDisabled={props.disabled}
            isClearable={true}
            options={formsList && formsList}
            isLoading={!formsList}
            loadingMessage={() => "Forms are loading..."}
            name="formId"
            placeholder="Select Form"
            value={selectedForm && formsList && Array.isArray(formsList) ? formsList.find(obj => obj.id === selectedForm.id) : null}
            onChange={(e) => {
                if (e?.id) {
                    setCurrentForm(e)
                } else {
                    setCurrentForm(null)
                }
            }}
            getOptionLabel={(option) => option.formTitle}
            getOptionValue={(option) => option.id}
        >
        </HPTSelect>
    )
}
export default FormSelector